export default __webpack_public_path__ + "static/media/foto3.ac13092a.jpg";